import {
  updateBank,
  putInwardCharges,
  postBankNew,
  updateOrg,
  putInwardPGCharges,
} from "../../../services/httpCalls";
import Cookies from "js-cookie";
import { cleanObject } from "../clean-object";

// Helpers: submission status rules
function isOpsUserFromCookie() {
  try {
    const raw = Cookies.get("userInfo");
    if (!raw) return false;
    const info = JSON.parse(raw);
    return (
      typeof info?.userType === "string" &&
      info.userType.toUpperCase() === "OPS"
    );
  } catch {
    return false;
  }
}

function shouldMarkBdamSubmitted(partnerState, localPartner) {
  const isArray = Array.isArray(partnerState);
  const hasBoth =
    isArray &&
    partnerState.includes("xflow") &&
    partnerState.includes("payglocal");
  const hasSingle = isArray && partnerState.length === 1;
  // when both present -> only mark when on payglocal; when single -> always
  return (hasBoth && localPartner === "payglocal") || hasSingle;
}

export const handleFinish = async ({
  mode,
  form,
  values,
  setShowLoader,
  editBank,
  editBankId,
  orgDetails,
  handleChange,
  finalSubmit,
  notify,
  navigate,
  partnerState,
  localPartner,
  value,
  setValue,
  setLocalPartner,
  isDraft,
}) => {
  setShowLoader(true);
  let orgId = localStorage.getItem("orgId");
  let data = {
    accountNumber: values.accountNumber,
    bankName: values.bankName,
    ifscCode: values?.ifscCode,
    status: "ACTIVE",
    isPrimaryAccount: true,
    isActiveForInward: true,
    isActiveForOutward: false,
    accountType: values?.selectedInwardBankAccountType ? "EEFC" : "SIMPLE",
  };
  let currencies = {};
  if (localPartner === "payglocal") {
    currencies = {
      initialCurrenciesForActivation: {
        currencies: values.currenciesList,
      },
      initialCurrenciesAmazonForActivation: {
        currencies: values.currenciesListAmazon,
      },
    };
  } else {
    if (
      !orgDetails?.initialCurrenciesForActivation?.currencies?.includes("USD")
    )
      currencies = {
        initialCurrenciesForActivation: {
          currencies: ["USD"],
        },
      };
  }
  let hubSpotData = {
    inwardHubspotDealId: values.inwardHubspotDealId,
  };
  //from form.json
  /*{
                    "type":"Form.Item",
                    "label":"Default Currencies",
                    "required":true,
                    "tooltip":"This is a required field!",
                    "labelCol":{ "span":16, "offset":0 },
                    "name":"defaultCurrencies",
                    "className":"defaultCharges",
                    "disabled":"orgDetails?.xflowAccountCreationStatus ? (orgDetails?.xflowAccountCreationStatus?.toUpperCase() === 'VERIFICATION' ? true : false) : false",
                    "rules":[
                        {
                            "required":true, 
                            "message":"Required!"
                        }
                    ],
                    "children":{
                        "type":"Checkbox.Group",
                        "props":{
                            "options":"currenciesList",
                            "disabled":"orgDetails?.xflowAccountCreationStatus?.toUpperCase() === 'VERIFICATION'"
                        }
                    }
                }, */
  //from form.json

  // Separate segment: non-OPS BD submission status update
  if (
    !isOpsUserFromCookie() &&
    shouldMarkBdamSubmitted(partnerState, localPartner)
  ) {
    try {
      await updateOrg({ accountSubmissionStatus: "SUBMITTED_BY_BD_AM" }, orgId);
    } catch (e) {
      notify.error("Failed to update submission status");
    }
  }

  let cleanCurrencies = cleanObject(currencies);
  await updateOrg(currencies, orgId)
    .then((res) => {
      if (res) {
        notify.success("Added default currencies!");
      }
    })
    .catch((err) => {
      if (err) {
        notify.error("Error in adding new currencies!");
        return;
      }
    });
  if (editBank) {
    let cleanData = cleanObject(data);
    if (partnerState.includes("payglocal")) {
      finalSubmit({ __draft: isDraft === true });
    }
    Promise.all([
      updateBank(orgId, editBankId, cleanData),
      updateOrg(hubSpotData, orgId),
    ])
      .then(([res1, res2]) => {
        if (res1) {
          if (localPartner === "payglocal") {
            let data = {
              fees: [],
            };
            values?.currenciesList?.map((currency) => {
              data["fees"].push({
                currency: currency,
                percentageFee: parseFloat(values?.variableCharges),
                minFee: parseFloat(values?.minimum),
              });
            });
            let cleanData = cleanObject(data);
            putInwardPGCharges(orgId, data)
              .then((res) => {
                if (orgDetails?.isOptOutward) {
                  handleChange(7);
                  Cookies.set("currentStage", "7");
                  if (mode === "edit") {
                    notify.success(
                      "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                    );
                  } else {
                    notify.success(
                      "Successfully posted bank details and Charges."
                    );
                  }
                } else {
                  try {
                    if (!partnerState.includes("payglocal")) {
                      finalSubmit({ __draft: isDraft === true });
                    }
                    if (mode === "edit") {
                      notify.success(
                        "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                      );
                    } else {
                      notify.success(
                        "Successfully posted bank details and Charges."
                      );
                    }
                    notify.success("Created Organization successfully!");
                    setTimeout(() => {
                      navigate("/orgs");
                    }, 700);
                  } catch {
                    console.log("Error");
                  }
                }
              })
              .catch((err) => {
                notify.error("Not able to post bank details and Charges");
              });
          } else {
            if (partnerState.includes("payglocal")) {
              finalSubmit({ __draft: isDraft === true });
            }
            let data = {
              payout: [
                {
                  destination_currency: "*",
                  fixed: `${values.fixedCharges}`,
                  minimum: values.minimum,
                  source_currency: "*",
                  variable: `${values.variableCharges}`,
                },
              ],
              payout_fx: [
                {
                  destination_currency: "*",
                  reference_rate: "mid_market",
                  source_currency: "*",
                  variable: `${values.fxMarkupCharges}`,
                },
              ],
              transfer_fx: [
                {
                  destination_currency: "*",
                  reference_rate: "mid_market",
                  source_currency: "*",
                  variable: `${values.fxMarkupCharges}`,
                  variable_off_hours: "2.00",
                },
              ],
            };
            let cleanData = cleanObject(data);
            putInwardCharges(orgId, cleanData)
              .then((res) => {
                if (partnerState.length > 1 && value !== 1) {
                  setValue(1);
                  setLocalPartner("payglocal");
                  const currentValues = form.getFieldsValue();
                  form.resetFields();
                  form.setFieldsValue({
                    inwardHubspotDealId: currentValues?.inwardHubspotDealId
                      ? currentValues.inwardHubspotDealId
                      : "",
                  });
                } else {
                  if (orgDetails?.isOptOutward) {
                    handleChange(7);
                    Cookies.set("currentStage", "7");
                    if (mode === "edit") {
                      notify.success(
                        "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                      );
                    } else {
                      notify.success(
                        "Successfully posted bank details and Charges."
                      );
                    }
                  } else {
                    try {
                      if (!partnerState.includes("payglocal")) {
                        finalSubmit({ __draft: isDraft === true });
                      }
                      if (mode === "edit") {
                        notify.success(
                          "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                        );
                      } else {
                        notify.success(
                          "Successfully posted bank details and Charges."
                        );
                      }

                      notify.success("Created Organization successfully!");
                      setTimeout(() => {
                        navigate("/orgs");
                      }, 700);
                    } catch {
                      console.log("Error");
                    }
                  }
                }
              })
              .catch((err) => {
                notify.error("Not able to post bank details and Charges");
              });
          }
        }
      })
      .catch(() => {
        notify.error("Not able to post details");
      })
      .finally(() => {
        setShowLoader(false);
      });
  } else {
    let cleanData = cleanObject(data);
    if (partnerState.includes("payglocal")) {
      finalSubmit();
    }
    Promise.all([postBankNew(data, orgId), updateOrg(hubSpotData, orgId)])
      .then(([res1, res2]) => {
        if (res1) {
          if (localPartner === "payglocal") {
            // let data = {
            //     "currencyFees": {
            //         "currency-USD": {
            //             "percentageFee": "0",
            //             "minFee": "0"
            //         }
            //     }
            // }
            // values?.currenciesList?.map(currency => {
            //     data["currencyFees"][`currency-${currency}`] = {
            //         "percentageFee": values?.variableCharges,
            //         "minFee": values?.minimum
            //     }
            // })
            let data = {
              fees: [],
            };
            values?.currenciesList?.map((currency) => {
              data["fees"].push({
                currency: currency,
                percentageFee: parseFloat(values?.variableCharges),
                minFee: parseFloat(values?.minimum),
              });
            });
            let cleanData = cleanObject(data);
            putInwardPGCharges(orgId, data)
              .then((res) => {
                if (orgDetails?.isOptOutward) {
                  handleChange(7);
                  Cookies.set("currentStage", "7");
                  if (mode === "edit") {
                    notify.success(
                      "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                    );
                  } else {
                    notify.success(
                      "Successfully posted bank details and Charges."
                    );
                  }
                } else {
                  try {
                    if (!partnerState.includes("payglocal")) {
                      finalSubmit();
                    }
                    if (mode === "edit") {
                      notify.success(
                        "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                      );
                    } else {
                      notify.success(
                        "Successfully posted bank details and Charges."
                      );
                    }
                    notify.success("Created Organization successfully!");
                    setTimeout(() => {
                      navigate("/orgs");
                    }, 700);
                  } catch {
                    console.log("Error");
                  }
                }
              })
              .catch((err) => {
                notify.error("Not able to post bank details and Charges");
              });
          } else {
            if (partnerState.includes("payglocal")) {
              finalSubmit({ __draft: isDraft === true });
            }
            let data = {
              payout: [
                {
                  destination_currency: "*",
                  fixed: `${values.fixedCharges}`,
                  minimum: values.minimum,
                  source_currency: "*",
                  variable: `${values.variableCharges}`,
                },
              ],
              payout_fx: [
                {
                  destination_currency: "*",
                  reference_rate: "mid_market",
                  source_currency: "*",
                  variable: `${values.fxMarkupCharges}`,
                },
              ],
              transfer_fx: [
                {
                  destination_currency: "*",
                  reference_rate: "mid_market",
                  source_currency: "*",
                  variable: `${values.fxMarkupCharges}`,
                  variable_off_hours: "2.00",
                },
              ],
            };
            let cleanData = cleanObject(data);
            putInwardCharges(orgId, data)
              .then((res) => {
                if (partnerState.length > 1 && value !== 1) {
                  setValue(1);
                  setLocalPartner("payglocal");
                  const currentValues = form.getFieldsValue();
                  form.resetFields();
                  form.setFieldsValue({
                    inwardHubspotDealId: currentValues?.inwardHubspotDealId
                      ? currentValues.inwardHubspotDealId
                      : "",
                  });
                  return;
                }
                if (orgDetails?.isOptOutward) {
                  handleChange(7);
                  Cookies.set("currentStage", "7");
                  if (mode === "edit") {
                    notify.success(
                      "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                    );
                  } else {
                    notify.success(
                      "Successfully posted bank details and Charges."
                    );
                  }
                } else {
                  try {
                    if (!partnerState.includes("payglocal")) {
                      finalSubmit({ __draft: isDraft === true });
                    }
                    if (mode === "edit") {
                      notify.success(
                        "Successfully posted bank details and Charges, Inward charges will be updated on T+1 day."
                      );
                    } else {
                      notify.success(
                        "Successfully posted bank details and Charges."
                      );
                    }
                    notify.success("Created Organization successfully!");
                    setTimeout(() => {
                      navigate("/orgs");
                    }, 700);
                  } catch {
                    console.log("Error");
                  }
                }
              })
              .catch((err) => {
                notify.error("Not able to post bank details and Charges");
              });
          }
        }
      })
      .catch(() => {
        notify.error("Not able to post details");
      })
      .finally(() => {
        setShowLoader(false);
      });
  }
};
